export default __webpack_public_path__ + "static/media/swen-splash.4fd389d2.png";